var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"tw-object-contain tw-h-[48px] xl:tw-h-[80px] tw-w-full tw-mb-4",attrs:{"alt":"Uptogether","src":_vm.logoUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }